import { Outlet } from "react-router-dom";

import {
  ClientFileApiProvider,
  DirtyFormContextProvider,
  NavigationBlocker,
  useStripAuthCallbackParams,
} from "@shared";

import { clientFileApi } from "@/api/clientFileApiAdapter";
import ClientsSearchContextProvider from "@/common/contexts/clients-search-context/ClientsSearchContextProvider";

export const RouterProviders = () => {
  useStripAuthCallbackParams();

  return (
    <DirtyFormContextProvider>
      <NavigationBlocker />
      <ClientFileApiProvider api={clientFileApi}>
        <ClientsSearchContextProvider>
          <Outlet />
        </ClientsSearchContextProvider>
      </ClientFileApiProvider>
    </DirtyFormContextProvider>
  );
};
